import React from "react"

import logoImg from "@/assets/images/logos/letalk-small-logo-white.svg"

import newColors from "@/styles/newColors"

import PortletWithSplitContent from "@/components/PortletWithSplitContent"
import { Typography } from "@material-ui/core"

const CheckEmailAfterUserCreatedPage: React.FC = () => {
	return (
		<PortletWithSplitContent
			title={{
				value: "Confirmação de email",
				logo: logoImg,
				backgroundColor: newColors.green[500],
				textColor: newColors.grey[0]
			}}
			body={{
				backgroundColor: newColors.grey[0]
			}}
		>
			<Typography
				align="center"
				variant="subtitle1"
			>
				Clique no link enviado para o seu email e acesse a Letalk!
			</Typography>
		</PortletWithSplitContent>
	)
}

export default CheckEmailAfterUserCreatedPage
